import React from 'react';
import useTrack from '../hooks/useTrack';
import AudioTrack, { AudioTrackWithGain } from './AudioTrack';
import VideoTrack from './VideoTrack';
import useIsTrackEnabled from "../hooks/useIsTrackEnabled";
export default function Publication(_ref) {
  var publication = _ref.publication,
      isLocal = _ref.isLocal,
      disableAudio = _ref.disableAudio,
      videoPriority = _ref.videoPriority,
      gainCorrection = _ref.gainCorrection;
  var track = useTrack(publication);
  var isVideoEnabled = useIsTrackEnabled(track);
  if (!track) return null;

  switch (track.kind) {
    case 'video':
      if (!isVideoEnabled) return null;
      return /*#__PURE__*/React.createElement(VideoTrack, {
        track: track,
        priority: videoPriority,
        isLocal: track.name.includes('camera') && isLocal
      });

    case 'audio':
      if (disableAudio) return null;

      if (gainCorrection) {
        return /*#__PURE__*/React.createElement(AudioTrackWithGain, {
          track: track,
          gain: gainCorrection,
          isLocal: isLocal
        });
      } else {
        return /*#__PURE__*/React.createElement(AudioTrack, {
          track: track
        });
      }

    default:
      return null;
  }
}